import TemplateMixin from './TemplateMixin';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { TextArea } from 'streamlabs-beaker';
import FontHelper from '@/helpers/font';

@Component({
  components: {
    STextArea: TextArea,
  },
})
export default class TextTemplateMixin extends Mixins(TemplateMixin) {
  editMode: boolean = false;
  textValue: string = '';
  isTappedTwice: boolean = false;
  animationInterval: number = 20;
  playingAnimation: boolean = false;
  tickerMaxLeft: number = 1380;
  tickerMinLeft: number = -1000;

  $refs!: {
    textValueContainer: HTMLElement;
    streamLabelVariableMenu: any;
  };


  @Watch('cssObject.fontSize')
  resizeTextComponent() {
    if (!this.$refs.textValueContainer) return;

    this.$nextTick(() => {
      const height = this.$refs.textValueContainer.clientHeight;
      const width = this.$refs.textValueContainer.clientWidth + 32;

      this.onComponentUpdate({
        id: this.component.id,
        h: height,
        w: width,
      });
    });
  }

  @Watch('editMode')
  checkComponentNewlyAdded() {
    this.$nextTick(() => {
      if (this.editMode && this.$refs[this.getComponentRefName(this.component)]) {
        (this.$refs[this.getComponentRefName(this.component)] as HTMLTextAreaElement).focus();
      }

      if (this.editMode && this.component?.newlyAdded) {
        const data = {
          value: '',
          newlyAdded: false,
        };

        this.onComponentUpdate({ ...this.component, ...data });
      }
    });
  }

  @Watch('component.value')
  updateTextValue() {
    this.textValue = this.component.value;
  }

  async loadFont() {
    let weight = this.component.css.fontWeight === 400 ? 'regular' : this.component.css.fontWeight;

    if (this.component.css.fontStyle === 'italic') {
      if (weight === 'regular') {
        weight = 'italic';
      } else {
        weight += 'italic';
      }
    }

    await FontHelper.loadWebFont({
      font: this.component.css.fontFamily || 'Roboto',
      weights: [weight],
    });
  }

  async doubleTapEditText() {
    // listen to double click
    if (!this.isTappedTwice) {
      this.isTappedTwice = true;
      setTimeout(() => {
        this.isTappedTwice = false;
      }, 300);

      return;
    }

    this.onDoubleClick();
  }

  onDoubleClick() {
    if (!this.isEditor) return;

    this.editMode = true;
    this.onComponentUpdate({ id: this.component.id, locked: true }, false);
  }

  onVariableSelected(input) {
    const regex = /^.*?\{(?!.*?\})[^}]*$/g;

    this.textValue = this.textValue.replace(regex, '');
    this.textValue += input;
  }

  get isTextTickerEnabled() {
    return this.component.css.tickerEnabled;
  }

  saveAndUpdate() {
    this.onComponentUpdate({ id: this.component.id, locked: false }, false);
    this.editMode = false;

    const hasChanged = this.component.value !== this.textValue;

    this.onComponentUpdate({ id: this.component.id, value: this.textValue }, hasChanged);
    this.$nextTick(() => {
      this.resizeTextComponent();
      this.updateTextValue();
      this.selectedComponent = null;
    });
  }

  get customCss() {
    return { '--backgroundColor': this.component.css.backgroundColor };
  }

  get styleVariables() {
    return {
      '--animationInterval': `${this.animationInterval}s`,
      '--maxLeft': `${this.tickerMaxLeft}px`,
      '--minLeft': `${this.tickerMinLeft}px`,
    };
  }

  @Watch('component.css.tickerEnabled')
  setFullWidthAndLockHorizontal() {
    if (!this.isEditor) return;

    const data = {
      lockHorizontal: this.component.css.tickerEnabled,
      isFullWidth: this.component.css.tickerEnabled
    };

    this.onComponentUpdate({ ...this.component, ...data });
  };
}
